import { type Theming, themingInitialState } from "@pandas/core-ui";
import type { PartnerSettings } from "@pandas/http-client";
import { StateCreator } from "zustand";
import {
	type ConfiguratorAppGlobalConfig,
	type ConfiguratorConfig,
	configurationInitialState,
	globalConfigurationInitialState,
} from "../../services/types";
import { Storage } from "../index";

export type AppConfig = ConfiguratorConfig & { theming: Theming; partnerSettings: PartnerSettings };

// INITIAL STATE
export type ConfigurationInfoSlice = {
	configurationInfo: AppConfig;
	globalConfigurationInfo: ConfiguratorAppGlobalConfig;
	setConfigurationInfo: (configuration: AppConfig) => void;
	setGlobalConfigurationInfo: (globalConfiguration: ConfiguratorAppGlobalConfig) => void;
};

const initialState = {
	configurationInfo: { ...configurationInitialState, theming: themingInitialState } as AppConfig,
	globalConfigurationInfo: globalConfigurationInitialState,
};

export const createConfigurationInfoSlice: StateCreator<
	Storage,
	[],
	[
		[
			"zustand/persist",
			{
				configuration: AppConfig;
				globalConfiguration: ConfiguratorAppGlobalConfig;
			},
		],
	],
	ConfigurationInfoSlice
> = (set) => ({
	...initialState,
	setConfigurationInfo: (configurationInfo: AppConfig) => set(() => ({ configurationInfo: configurationInfo })),
	setGlobalConfigurationInfo: (globalConfigurationInfo: ConfiguratorAppGlobalConfig) =>
		set(() => ({ globalConfigurationInfo: globalConfigurationInfo })),
});
